module.exports = __webpack_public_path__ + "media/images/illustrations/unit_sizes/10x15_small-ff47c55724781fa4fbe5b50071d23809.png";